import type { RatingComponentProps } from 'react-rating';
import Rating from 'react-rating';

// @ts-ignore
export const ReactRating: FC<RatingComponentProps> = (props) => <Rating {...props} />;
